'use strict';

angular.module('more.ui.form-builder').factory('$fileSystemService', function () {
  // no-op
  return {};
});